<template>
  <div>
    <v-select
      :value="value"
      label="Tipo de Consulta"
      :items="appointmentTypes"
      @input="setAppointmentType"
    />
    <v-textarea
      v-if="value === 'multidisciplinar-appointment'"
      label="Notas"
      :value="notes"
      outline
      @input="setMultiDiciplinaryNote"
    />
  </div>
</template>

<script>
import { Option } from '../../../models/Specialty'
export default {
  props: {
    value: { type: String, default: '' },
    notes: { type: String, default: '' }
  },
  computed: {
    appointmentTypes() {
      return (
        Option.query()
          .where('component', 'appointment-type')
          .get() || []
      )
    }
  },
  methods: {
    setAppointmentType(val) {
      this.$emit('input', val)
    },
    setMultiDiciplinaryNote(val) {
      this.$emit('update:notes', val)
    }
  }
}
</script>

<style></style>
